// extracted by mini-css-extract-plugin
module.exports = {"infiniteScroll":"LecturerSearch_infiniteScroll__39c8z","listItem":"LecturerSearch_listItem__3buTv","spin360":"LecturerSearch_spin360__111Qn"};